import React, { useState, useEffect, useRef } from 'react';
import useApi from '../../api/useApi';
import Moment from 'react-moment';
import { useNavigate } from 'react-router-dom';

const Home = () => {
    const [auction, setAuction] = useState({});
    const navigate = useNavigate();
    const api = useApi();

    const loadAuctioneerDashboard = async () => {
        await api.getAuctioneerDashboard().then((data) => {
            console.log(data)
            setAuction(data)
        })
    }

    useEffect(() => {
        loadAuctioneerDashboard();
    }, []);

    const handleAuctionDetail = () => {
        if (auction?.auctionStatus > - 1)
            navigate(`/LotUpdateView/${auction.auctionId}`);
        else
            alert("Action not allowed. No auction.")
    }

    return (
        <div className="inner-body">
            <div className="page-header">
                <div>
                    <h2 className="main-content-title tx-24 mg-b-5">Home</h2>
                    {/*<ol className="breadcrumb">*/}
                    {/*    <li className="breadcrumb-item">*/}
                    {/*        <a href="#">Home</a></li>*/}
                    {/*    <li className="breadcrumb-item active" aria-current="page">Home</li>*/}
                    {/*</ol>*/}
                </div>
                <div className="d-flex">

                </div>
            </div>
            <div className='panel panel-default'>
                <div className="row-sm row">
                   
                    <div className="col-md-6">
                        <div className="card custom-card card-body">
                            <div>
                                {auction?.auctionStatus > -1 ?
                                    <h2 className="tx-18 text-muted mb-0"> <strong> {auction?.companyName}</strong>  <br></br> <span className="badge bg-primary-light me-1">{auction?.message} </span> |  <Moment format="DD-MMM-YYYY">{auction?.auctionDate}</Moment>{" "}  {auction?.startTime ? <span><Moment format="LT">{auction?.startTime}</Moment>{"  to  "}<Moment format="LT">{auction?.endTime}</Moment></span> : null} </h2>
                                    : <p className="tx-18 text-muted mb-0"> <span className="badge  bg-primary-light  me-1">{auction?.message} </span> <br></br> <i><small> Please contact your administrator.</small></i>  </p>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="card custom-card card-body">
                            <div>
                                {auction?.auctionStatus > -1 ?
                                    <div>   <h4 className="tx-18 mb-0 text-primary pointer"  onClick={handleAuctionDetail}>View Current Auction Progress </h4>
                                        <span className="text-muted">View list of lots & auction progress. You can withdraw Sold lots until auction is not closed</span>
                                    </div>
                                    : <p className="tx-18 text-muted mb-0"> <span className="badge  bg-primary-light  me-1">{auction?.message} </span> <br></br> <i><small> Please contact your administrator.</small></i>  </p>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           
        </div>
    );
}

export default Home;